import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideDeleteRuleConfirm() {
  return hideDialog(DialogName.DELETE_RULE_CONFIRM)();
}
